module.exports = __webpack_public_path__ + "img/icon-fast.270cbb3.png";